import {
  ManagerSegment,
  ManagerSegmentAnswerValue,
  ManagerSegmentQuestion
} from './server';

export type IManagerSegmentVisibility = {
  showSegment: boolean;
};

export type IManagerSegmentAnswer = {
  question: ManagerSegmentQuestion;
  values: ManagerSegmentAnswerValue[];
};

export type IManagerSegmentComplete = {
  segment: ManagerSegment;
  answers: IManagerSegmentAnswer[];
  segmentOtherText: string | null;
  taskOtherText: string | null;
};

export enum ManagerSegmentSelectionMode {
  single = 'single',
  multiple = 'multiple'
}

export type IManagerSegmentQuestionDefinition = {
  question: ManagerSegmentQuestion;
  selectionMode: ManagerSegmentSelectionMode;
  values: ManagerSegmentAnswerValue[];
  allowsOther: boolean;
};

export enum ManagerSegmentStep {
  segment = 'segment',
  questions = 'questions',
  success = 'success'
}

export const getManagerSegmentTextLength = (value: string): number =>
  Array.from(value).length;
